export default __webpack_public_path__ + "static/media/doctors-portal.5f8666a5.png";